import { PartnerLayout } from '@/layouts/PartnerLayout';
import { ClientsPage } from '@/pages/clients/ClientsPage';
import { validateClientsSearch } from '@/pages/clients/clientsSearch';
import { LoginPage } from '@/pages/login/LoginPage';
import { PrescriptionStatusPage } from '@/pages/prescriptions/PrescriptionStatusPage';
import { validatePrescriptionsSearch } from '@/pages/prescriptions/prescriptionsSearch';
import { UsersPage } from '@/pages/users/UsersPage';
import { validateUsersSearch } from '@/pages/users/usersSearch';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { NotFound } from '@/shared/components/NotFound';
import { ROUTE_PATHS } from '@/shared/constants/routes';
import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
} from '@tanstack/react-router';

const rootRoute = createRootRoute({
  component: () => <Outlet />,
  errorComponent: ErrorBoundary,
  notFoundComponent: NotFound,
});

// 01 로그인
const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: ROUTE_PATHS.LOGIN,
  component: LoginPage,
});

// 로그인 후 공통 레이아웃 (pathless)
const partnerRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'partner',
  component: PartnerLayout,
  errorComponent: ErrorBoundary,
});

// 05 사용자
const usersRoute = createRoute({
  getParentRoute: () => partnerRoute,
  path: ROUTE_PATHS.USERS,
  validateSearch: validateUsersSearch,
  component: UsersPage,
});

// 06 거래처 정보
const clientsRoute = createRoute({
  getParentRoute: () => partnerRoute,
  path: ROUTE_PATHS.CLIENTS,
  validateSearch: validateClientsSearch,
  component: ClientsPage,
});

// 07 처방 등록 현황
const prescriptionsRoute = createRoute({
  getParentRoute: () => partnerRoute,
  path: ROUTE_PATHS.PRESCRIPTIONS,
  validateSearch: validatePrescriptionsSearch,
  component: PrescriptionStatusPage,
});

export const routeTree = rootRoute.addChildren([
  loginRoute,
  partnerRoute.addChildren([usersRoute, clientsRoute, prescriptionsRoute]),
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
